export default {
    carbonCredit: {
        view: 'View',
        edit: 'Edit',
        back: 'Back',
        preview: 'Preview',
        confirm: 'Confirm',
        cancel: 'Cancel',
        dashboard: 'Dashboard',
        select: 'Select',
        submit: 'Submit',
        save: 'Save',
        title: 'Carbon Credit',
        projects: 'Projects',
        carbonProjectCredits: 'Carbon Project Credits',
        carbonCreditProjects: 'Carbon Credit Projects',
        exportAs: 'Export as',
        downloadAsCSV: 'Download as CSV',
        downloadAsExcel: 'Download as Excel',
        downloadAsPDF: 'Download as PDF',
        registerNewProject: 'Register New Project',  
        creditInfo: '*This is approximate number of credits. Actual number of credits might be different after verification.',
        search: 'Search',
        projectTitle: 'Project Title',
        projectType: 'Project Type',
        country: 'Country',
        totalCreditsGenerated: 'Total Credits Generated',
        status: 'Status',
        descriptionPlaceholder: "Please provide description of the project including goals",
        filePreviewNotAvailable: 'File preview is not available for this file type',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        proposed: 'Proposed',
        planned: 'Planned',
        inProgress: 'In Progress',
        operational: 'Operational',
        deactivated: 'Deactivated',
        avoidedDeforestation: 'Avoided Deforestation',
        agroForestry: 'Agroforestry',
        forestry: 'Forestry',
        regenerativeAgriculture: 'Regenerative Agriculture',
        agroforestry: 'Agroforestry',
        regenerative_agriculture: 'Regenerative Agriculture',
        projectDeletedSuccessfully: 'Project deactivated successfully',
        projectUpdatedSuccessfully: 'Project updated successfully',
        projectRegisteredSuccessfully: 'Project registered successfully',
        deactivateProjectError: 'Error deactivating project',
        deactivate: 'Deactivate',
        deactivateProject: 'Deactivate Project',
        deactivateConfirmation: 'Are you sure you want to deactivate this project?',
        registerProject: 'Register a New Project',
        editProject: 'Edit Project',

        register: { 
            title: 'Register a Project',
            editTitle: 'Edit Project',
            projectTitle: 'Project Title',
            projectType: 'Project Type',
            description: 'Description',
            selectCountry: "Select Country",
            selectOrganization: 'Select Organizations',
            status: 'Status',
            creditType: 'Credit Type',
            creditStart: 'Credit Start',
            creditEnd: 'Credit End',
            standardMethodology: 'Standard/Methodology',
            validationDocumentation: 'Validation Documentation',
            vintage: 'Vintage',
            currency: 'Currency',
            projectInfo: 'Project Info',
            organizationDetails: 'Organizations Details',
            attachmentTitle: 'Attachment(s)',
            attachmentInfo: 'You can add any additional documents, images, video and audio files relevant to the project',
            documentation: 'Documentation',
            sdgsTitle: 'Sustainable Development Goals (SDGs)',
            sdgsInfo: 'Please select only the goals relevant to this specific project. The organizations will have access to view only the goals linked to this project.',
            dataCollectionTitle: 'Data Collection Cycle',
            dataCollectionInfo: 'To participate in the Carbon Credit Program, farmers must provide historical farm data during enrollment and continue submitting periodic data updates for as long as the program remains active. This ensures accurate tracking of carbon performance over time.',
            vintageYear: 'Vintage Year',
            estimatedCredit: 'Estimated Credits',
            pricePerCredit: 'Price Per Credit',
            moduleName: 'Module Name',
            futureData: 'Future Recurring Data Collection',
            score: 'Score',
            approval: 'Approval',

            projectAgreement: 'Project Agreement',
            headerImage: 'Header Image',
            headerImageInfo: '(Header image size 1920 x 420 pixels. Default image will be replaced with new image you upload)',
            headerImagePlaceholder: "Default Header Image",
            responsibleDimitraOffice: 'Responsible Dimitra Office',
            selectDimitraOffice: 'Select Dimitra Office',
            makeASelection: 'Make a Selection',
            addNewDimitraOffice: 'Add New Dimitra Office',
            officeName: 'Office Name',
            contactPerson: 'Contact Person Name',
            phoneNumber: 'Phone Number',
            email: 'Email',
            address: 'Address',
            officeNameRequired: 'Office name is required',
            contactPersonRequired: 'Contact person name is required',
            addressRequired: 'Address is required',
            phoneNumberRequired: 'Phone number is required', 
            phoneNumberInvalid: 'Phone number is invalid',
            phoneNumberLength: 'Phone number must be at least 10 digits long',
            selectVintage: 'Select Vintage',
            officeAddedSuccessfully: 'Dimitra office added successfully',
            errorAddingOffice: 'Error adding Dimitra office',
            searchOrganizations: 'Search Organizations',
            searchOrganizationsPlaceholder: 'Search by organization name...',
            noOrganizationsFound: 'No organizations found',
            selectedOrganizations: 'Selected Organizations',
            errorNegative: 'cannot be negative.',
            errorRequiredField: '{field} is required.',
            errorOrganizationRequired: 'At least one organization must be selected.',
            errorVintageRequired: 'At least one vintage entry is required.',
            errorVintageFieldsRequired: 'All vintage fields (year, credits, price) are required.',
            allOrganizations: 'All Organizations',
            removal: 'Removal',
            avoided: 'Avoided',
            mandatory: 'Mandatory',
            scoreValidationError: 'Invalid score for module "{module}". Score must be a whole number 0 or greater.',
            approvalValidationError: 'Invalid approval for module "{module}". Approval must be a whole number between 0 and 100.',
            saveError: 'Failed to save project',
            fileUploadFailed: 'File Upload Failed',
            unsupportedFileFormat: 'Unsupported file format',
            errorUploadingFile: 'Error uploading file',
            scoreError: {
                invalid: 'Score must be a valid number',
                range: 'Score must be 0 or greater',
                wholeNumber: 'Score must be a whole number'
            },
            approvalError: {
                invalid: 'Approval must be a valid number',
                range: 'Approval must be between 0 and 100',
                wholeNumber: 'Approval must be a whole number'
            },
            selectStatus: 'Select Status',
            selectCreditType: 'Select Credit Type',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standard',
            browse: 'Browse',
            currencyPlaceholder: 'USD',
                    selectFile: 'Select File',
        dragDropFiles: 'Drag & Drop files here',
        hideDetails: 'Hide Details',
        viewDetails: 'View Details',
        website: 'Website',
        month: 'Month(s)',
        year: 'Year(s)',
    },

        error: 'Error',
        success: 'Success',
        remove: 'Remove',

        plotTreeMapping: {
            title: 'Plot Tree Mapping',
            addANewRequest: 'Add a New Request',
            plot: 'Plot',
            tree: 'Tree',
            status: 'Status',
            action: 'Action',
            request: 'Plot Tree Mapping Request',
            cancelRequest: "Cancel Request",
            choosePlotLocation: 'Choose Plot Location',
            chooseFarmLocation: 'Choose Farm Location',
            longitude: 'Longitude',
            latitude: 'Latitude',
            plotRadius: 'Plot Radius',
            additionalNotes: 'Additional Notes',
            searchAddress: 'Search address',
            radius: 'Radius',
            enterLongitude: 'Enter Longitude',
            enterLatitude: 'Enter Latitude',
            enterRadius: 'Enter Radius',
            deleteRequest: 'Delete Request',
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        
        projectInfo: {
            title: 'Project Info',
            organizationDetail: 'Organization Detail',
            subOrganizations: 'Sub-Organizations',
            search: 'Search',
            organizations: 'Organizations',
            users: 'Users',
            registrationDate: 'Registration Date',
            close: 'Close',
            country: 'Country',
            organizationsAddress: 'Organizations Address',
            blockchainAddress: 'Blockchain Address',
            creditType: 'Credit Type',
            projectType: 'Project Type',
            officeName: 'Office Name',
            contactPersonName: 'Contact Person Name',
            contactNumber: 'Contact Number',
            email: 'Email',
            address: 'Address',
            website: 'Website',
            vintageYear: 'Vintage Year',
            estimatedCredits: 'Estimated Credits',
            pricePerCredit: 'Price Per Credit',
            module: 'Module',
            recurring: 'Recurring',
            score: 'Score',
            approval: 'Approval',
            responsibleDimitraOffice: 'Responsible Dimitra Office',
            status: 'Status',
            standardMethodology: 'Standard/Methodology',
            validationDocumentation: 'Validation Documentation',
            creditStart: 'Credit Start',
            creditEnd: 'Credit End',
            attachmentTitle: 'Attachment(s)',
            sdgsTitle: 'Sustainable Development Goals (SDGs)',
            dataCollectionTitle: 'Data Collection Cycle',
            dataCollectionInfo: 'To participate in the Carbon Credit Program, farmers must provide historical farm data during enrollment and continue submitting periodic data updates for as long as the program remains active. This ensures accurate tracking of carbon performance over time.',
            vintage: 'Vintage',
            moduleName: 'Module Name',
            futureData: 'Future Recurring Data Collection',
            estimatedCredit: 'Estimated Credits',
        },

        user: {
            title: 'Carbon Credit User(s)',
            selectOrganization: 'Select Organization',
            selectProject: 'Select Project',
            allUsers: 'All Users',
            activeUsers: 'Active Users',
            deactivatedUsers: 'Deactivated Users',
            pendingUsers: 'Pending Users',
            search: 'Search',
            farmerName: 'Farmer Name',
            farmName: 'Farm Name',
            organizations: 'Organizations',
            country: 'Country',
            projectTitle: 'Project Title',
            registerProject: 'Register a New Project',
            actions: 'Actions',
            noData: 'No users found.',
            view: 'View',
            viewLandPermit: 'View Land Title / Permit',
            edit: 'Edit',
            deactivate: 'Deactivate',
            deactivateConfirmation: 'Are you sure you want to deactivate this user?',
            deactivateUser: 'Deactivate User',
            activate: 'Activate',
            activateUser: 'Activate User',
            activateConfirmation: 'Are you sure you want to activate this user?',
            deactivatedSuccessfully: 'User deactivated successfully',
            activatedSuccessfully: 'User activated successfully',
            deactivationFailed: 'Failed to deactivate user',
            activationFailed: 'Failed to activate user',
            exportAsPdf: 'Export as PDF',
            projectDetails: 'Project Details',
            dateJoined: 'Date Joined',
            cropGrowingPractice: 'Crop Growing Practice',
            farm: 'Farm',
            rejectAll: 'REJECT ALL',
            acceptAll: 'ACCEPT ALL',
            confirmRejectAll: 'You are about to reject requests for all farms to join the carbon credit project. This action will exclude every farm submitted by the farmer in this request. Are you sure you want to proceed?',
            confirmAcceptAll: 'You are about to accept requests for all the farms to join the carbon credit project. This action will include every farm submitted by the farmer in this request. Are you sure you want to proceed?',
            dateOfRegistration: 'Date of Registration',
            farmRegistrationId: 'Farm Registration ID',
            dimitraFarmId: 'Dimitra Farm ID',
            notTheFarmer: "I'm not the Farmer",
            farmerFirstName: 'Farmer First Name',
            farmerMiddleName: 'Farmer Middle Name',
            farmerLastName: 'Farmer Last Name',
            farmerRegistrationId: 'Farmer Registration ID',
            dimitraFarmerId: 'Dimitra Farmer ID',
            farmGeofence: 'Farm Geofence',
            viewGeofence: 'View Geofence',
            totalFarmSize: 'Total Farm Size',
            mainGoals: 'What are Your Main Goals',
            ownershipType: 'Ownership Type',
            certifications: 'Certification(s)',
            productionType: 'Production Type',
            landTitle: 'Land Title',
            farmLocationAddress: 'Farm Location Address',
            farmCoordinate: 'Farm Coordinate',
            farmerAgreement: 'Farmer Agreement',
            viewSignedAgreement: 'View signed agreement submitted with the application.',
            viewAgreement: 'VIEW AGREEMENT',
            acceptanceStatus: 'Acceptance Status',
            currentStatus: 'Current Status',
            reject: 'REJECT',
            accept: 'ACCEPT',
            farmActivitySubmissions: 'Farm Activity Submissions',
            farmActivitySubmissionsDesc: 'Submitted records of farming practices and updates required for carbon credit verification.',
            viewFarmData: 'VIEW FARM DATA',
            farmData: 'Farm Data',
            farmDataDesc: 'Create your reports by integrating production data from various sources. Select one or multiple sources to compile a comprehensive list of production places for your reports.',
            crops: 'Crops',
            sowing: 'Sowing',
            seedling: 'Seedling',
            fertilizer: 'Fertilizer',
            fertilizerError: 'Submission incomplete: Fertilizer information for 4 months are missing from the farmer\'s entry.',
            harvesting: 'Harvesting',
            livestock: 'Livestock',
            equipment: 'Equipment',
            projectRequests: 'Project Requests',
            userNameAndId: 'User Name & ID',
            email: 'Email',
            userRole: 'User Role',
            status: 'Status',
            userRegistrationDate: 'User Registration Date',
            pending: 'Pending',
            deactivated: 'Deactivated',
            active: 'Active',
            selectProjectTypeFirst: 'Select Project Type First',
        },
    }
}